import { host } from './host';

export const isChineseDomain = host === 'terminal.prx-pay.com';
